import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { applyPageSeo } from "@/lib/seo";
import { BookOpen, ArrowRight } from "lucide-react";

// Curated icon/gradient per category for visual variety (no purple/teal)
const CATEGORY_ART = {
  "Coffee Table Books": "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1200&q=80",
  "Agriculture": "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=1200&q=80",
  "Anthropology and Sociology": "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80",
  "Art and Archaeology": "https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?w=1200&q=80",
  "Art Gallery's Books": "https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=1200&q=80",
  "Biography and Autobiography": "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1200&q=80",
  "Botany": "https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=1200&q=80",
  "Buddhism": "https://images.unsplash.com/photo-1518098168897-8ba0b6a76a3f?w=1200&q=80",
  "Chemical Petroleum": "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1200&q=80",
  "Architecture & Building": "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=1200&q=80",
  "Physics": "https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?w=1200&q=80",
  "Children Books": "https://images.unsplash.com/photo-1476081718509-d5d0b661a376?w=1200&q=80",
  "Cookery": "https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=1200&q=80",
  "Economics": "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=1200&q=80",
  "Engineering": "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=1200&q=80",
  "Fashion Designing": "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=1200&q=80",
  "Fisheries": "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=1200&q=80",
  "General and Reference": "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=1200&q=80",
  "History": "https://images.unsplash.com/photo-1461360370896-922624d12aa1?w=1200&q=80",
  "Home Decoration and Furniture Designing": "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=1200&q=80",
  "Horticulture": "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?w=1200&q=80",
  "Indian Politics and International Relations": "https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=1200&q=80",
  "Law": "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&q=80",
  "Medical Plants": "https://images.unsplash.com/photo-1471193945509-9ad0617afabf?w=1200&q=80",
  "Medical Sciences": "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=80",
  "Military Studies": "https://images.unsplash.com/photo-1580793241796-5b58a5b45cc4?w=1200&q=80",
  "North East India": "https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=1200&q=80",
  "Old and Rare Books": "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=1200&q=80",
  "Performing Arts": "https://images.unsplash.com/photo-1503095396549-807759245b35?w=1200&q=80",
  "Philosophy and Religion": "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=1200&q=80",
  "Science and Technology": "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=1200&q=80",
  "South Asian Studies": "https://images.unsplash.com/photo-1548013146-72479768bada?w=1200&q=80",
  "Tibetan & Nepal": "https://images.unsplash.com/photo-1544198365-f5d60b6d8190?w=1200&q=80",
  "Veterinary Sciences": "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=1200&q=80",
  "Zoology": "https://images.unsplash.com/photo-1474511320723-9a56873867b5?w=1200&q=80",
  "School Books": "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=1200&q=80",
  "Reference": "https://images.unsplash.com/photo-1519682337058-a94d519337bc?w=1200&q=80",
  "Competitive": "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=1200&q=80",
  "Kids": "https://images.unsplash.com/photo-1476081718509-d5d0b661a376?w=1200&q=80",
  "Story Books": "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=1200&q=80",
};

export default function Categories() {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    applyPageSeo({
      title: "Browse Book Categories — Art, History, Law, Buddhism & more | GAINA THE PRELUDE",
      description: "Explore every category of books distributed by GAINA THE PRELUDE — Art & Archaeology, History, Law, Buddhism, Children Books, Science and Technology, South Asian Studies and more. Trusted by universities and libraries worldwide.",
      keywords: "book categories, art books, history books, law books, buddhism books, children books, science books, GAINA THE PRELUDE, books distributor, library supplier",
      path: "/categories",
    });
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/categories");
        setCats(data);
      } catch (e) {
        console.error("categories load failed", e);
      }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="categories-page">
      <div className="border-b-2 border-[#09090b] pb-6 mb-8">
        <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#ea580c]">Browse Everything</div>
        <h1 className="font-display text-4xl md:text-6xl font-black tracking-tighter mt-2">All Categories</h1>
        <p className="text-[#52525b] mt-3 max-w-2xl">From Coffee Table books to Veterinary Sciences — discover the full range of titles we distribute across India.</p>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array(12).fill(0).map((_, i) => (
            <div key={i} className="aspect-[4/3] border border-border bg-[#f4f4f5] animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="categories-grid">
          {cats.map((c) => (
            <Link
              key={c.name}
              to={`/books?category=${encodeURIComponent(c.name)}`}
              className="group relative aspect-[4/3] overflow-hidden border border-border bg-black hover:border-[#ea580c] transition-all"
              data-testid={`category-card-${c.name}`}
            >
              {CATEGORY_ART[c.name] ? (
                <img
                  src={CATEGORY_ART[c.name]}
                  alt={c.name}
                  className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-110 transition-all duration-500"
                  loading="lazy"
                />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center">
                  <BookOpen className="w-16 h-16 text-white/30" />
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-between p-5">
                <div className="flex items-center justify-end">
                  <ArrowRight className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
                <div className="font-display text-xl md:text-2xl font-black text-white leading-tight">{c.name}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
